import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

client.interceptors.request.use(
  config => {
    const token = localStorage.getItem("charisma-token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

export default client;
